import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../Common/Loader";
import AuthContext from "../../Context/AuthContext";
import ajaxRequisitions from "../../util/remote/ajaxRequisitions";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import ajaxDepartments from "../../util/remote/ajaxDepartments";
const CreateRequisition = () => {
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Form fields
  const [deptID, setDeptID] = useState("");
  const [naration, setNaration] = useState("");
  const [dateCreated, setDateCreated] = useState(() => {
    const today = new Date();
    return today.toLocaleDateString("en-CA"); // YYYY-MM-DD local
  });

  // Rows state
  const [rows, setRows] = useState([
    { item_name: "", quantity: "", estimated_cost: "", unit: "" },
  ]);
  // Departments
  const [departments, setDepartments] = useState([]);
  // Fetch departments
  const fetch_departmentList = async () => {
    const server_response = await ajaxDepartments.fetchDepartmentsList({});
    if (server_response.status === "OK") {
      setDepartments(
        server_response.details.map((d) => ({
          value: d.id,
          label: d.department,
        }))
      );
    } else {
      toast.error(server_response.message);
    }
  };
  useEffect(() => {
    fetch_departmentList();
  }, []);
  // Row handlers
  const handleAddRow = () => {
    const lastRow = rows[rows.length - 1];
    if (
      !lastRow.item_name ||
      !lastRow.quantity ||
      !lastRow.estimated_cost ||
      !lastRow.unit
    ) {
      toast.error("Please complete the current row before adding a new one.");
      return;
    }
    setRows([
      ...rows,
      { item_name: "", quantity: "", estimated_cost: "", unit: "" },
    ]);
  };
  const handleDeleteRow = (index) => {
    const updatedRows = rows.filter((_, idx) => idx !== index);
    setRows(
      updatedRows.length
        ? updatedRows
        : [{ item_name: "", quantity: "", estimated_cost: "", unit: "" }]
    );
  };
  const handleRowChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };
  // Calculations
  const calculateRowSubtotal = (row) => {
    return (
      (parseFloat(row.quantity) || 0) * (parseFloat(row.estimated_cost) || 0)
    );
  };
  const calculateTotal = () => {
    return rows.reduce((total, row) => total + calculateRowSubtotal(row), 0);
  };
  const formatMoney = (value) => {
    return value.toLocaleString("en-UG", {
      style: "currency",
      currency: "UGX",
      minimumFractionDigits: 2,
    });
  };
  const allRowsFilled = () => {
    return (
      deptID &&
      rows.every(
        (row) => row.item_name && row.quantity && row.estimated_cost && row.unit
      )
    );
  };
  // Submit
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!deptID || !naration || rows.length === 0) {
      toast.error("Please complete all fields");
      return;
    }
    const data = {
      created_by: userId,
      deptID: deptID.value,
      naration,
      est_total: calculateTotal(),
      date_created: dateCreated,
      req_items_array: rows.map(
        ({ item_name, quantity, estimated_cost, unit }) => ({
          item_name,
          quantity: Number(quantity),
          estimated_cost: Number(estimated_cost),
          unit,
        })
      ),
    };
    setLoading(true);
    const response = await ajaxRequisitions.createRequisition(data);
    setLoading(false);
    if (response.status === "OK") {
      toast.success(response.message);
      resetForm();
    } else {
      toast.error(response.message);
    }
  };
  const resetForm = () => {
    setDeptID(null);
    setNaration("");
    setRows([{ item_name: "", quantity: "", estimated_cost: "", unit: "" }]);
    setDateCreated(new Date().toISOString().split("T")[0]);
  };
  return (
    <AppContainer title="Create Requisition">
      <div className="container-fluid">
        <Toaster />
        <div className="row mb-3">
          <div className="col-lg-3">
            <button
              className="btn btn-primary btn-sm"
              onClick={() => navigate("/requisitions/View")}
            >
              View Requisitions
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="card custom-card" style={{ borderRadius: "10px" }}>
              <div className="card-body">
                <h6 className="card-title mb-4">Add Requisition</h6>
                <form onSubmit={handleAdd}>
                  <div className="row mb-4">
                    <div className="col-md-6">
                      <label>
                        Department <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        options={departments}
                        value={deptID}
                        onChange={setDeptID}
                        placeholder="Select Department"
                      />
                    </div>
                    <div className="col-md-6">
                      <label>
                        Naration <span style={{ color: "red" }}>*</span>
                      </label>
                      <textarea
                        value={naration}
                        onChange={(e) => setNaration(e.target.value)}
                        className="form-control"
                        placeholder="Description"
                        required
                      />
                    </div>
                    <div className="col-md-4 mt-3">
                      <label>
                        Date Created <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        value={dateCreated}
                        onChange={(e) => setDateCreated(e.target.value)}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                  {/* Items Table */}
                  <div className="mb-4 col-md-12">
                    <table className="table table-bordered table-hover text-nowrap mg-b-0">
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Item Name</th>
                          <th>Quantity</th>
                          <th>Unit</th>
                          <th>Unit Cost</th>
                          <th>Subtotal</th>
                          <th>Operations</th>
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map((row, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <input
                                className="form-control"
                                type="text"
                                value={row.item_name}
                                onChange={(e) =>
                                  handleRowChange(
                                    index,
                                    "item_name",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="number"
                                min={1}
                                value={row.quantity}
                                onChange={(e) =>
                                  handleRowChange(
                                    index,
                                    "quantity",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="text"
                                value={row.unit}
                                placeholder="Unit e.g. pcs, kg"
                                onChange={(e) =>
                                  handleRowChange(index, "unit", e.target.value)
                                }
                              />
                            </td>
                            <td>
                              <input
                                className="form-control"
                                type="number"
                                min={0}
                                value={row.estimated_cost}
                                onChange={(e) =>
                                  handleRowChange(
                                    index,
                                    "estimated_cost",
                                    e.target.value
                                  )
                                }
                              />
                            </td>
                            <td>{formatMoney(calculateRowSubtotal(row))}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => handleDeleteRow(index)}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={7}>
                            <button
                              type="button"
                              onClick={handleAddRow}
                              className="btn btn-secondary btn-sm"
                            >
                              Add Row
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  {/* Total */}
                  <div className="mb-4 col-md-12">
                    <p>Total Estimated Cost: {formatMoney(calculateTotal())}</p>
                  </div>
                  <div className="d-flex justify-content-center col-lg-12">
                    <button
                      type="submit"
                      className="btn btn-success col-lg-12"
                      disabled={!allRowsFilled() || loading}
                    >
                      {loading ? <Loader /> : "Add Requisition"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AppContainer>
  );
};
export default CreateRequisition;
